import { Memory } from 'es6/models/memory';

export default class StudyNode {
  constructor(attrs = {}) {
    _.defaults(this, attrs, {
      applicationType: null,  // NOTE: This is not returned by the API.
      contentDomain: null,
      contentId: null,
      itemId: null,           // Used by sentences
      goalId: null,
      quizSequence: null,
      extraQuizzes: null,
      memory: null,
    });

    if (this.memory && !(this.memory instanceof Memory)) {
      this.memory = new Memory(this.memory);
    }
  }

  isReady() {
    return !this.memory || this.memory.isReady();
  }
}
